import React from 'react';
import { Card, Stack } from 'react-bootstrap';
import { LinkCell } from '../../../../../components/tables/cellComponents/LinkCell';
import { Order } from '../../../../../types/orders.type';

export interface UpdateChildProps {
    order: Order;
}

export const UpdateChild: React.FC<UpdateChildProps> = ({ order }) => {
    const { registrations } = order;
    return (
        <Stack gap={2}>
            {registrations.map((r) => (
                <Card
                    key={r.id}
                    className="update-child-card"
                >
                    <Card.Body>
                        <Stack gap={2}>
                            <div className="update-child-field update-child-field--inline">
                                <Card.Subtitle className="text-muted mb-0">Child</Card.Subtitle>
                                <LinkCell
                                    url="/user/profile"
                                    content={r.child.full_name}
                                />
                            </div>
                            <div className="update-child-field update-child-field--inline">
                                <Card.Subtitle className="text-muted mb-0">Grade</Card.Subtitle>
                                <span>{r.child.grade_level}</span>
                            </div>
                            <div className="update-child-field">
                                <Card.Subtitle className="text-muted mb-1">Teacher / Classroom</Card.Subtitle>
                                <span>{r.child.origination}</span>
                            </div>
                            <hr className="my-1" />
                            <div className="update-child-field">
                                <Card.Subtitle className="text-muted mb-1">
                                    Allergies &amp; Dietary Restrictions
                                </Card.Subtitle>
                                {r.child.allergies && r.child.allergies.length > 0 ? (
                                    r.child.allergies.map((a, index) => (
                                        <span
                                            key={index}
                                            className="d-block"
                                        >
                                            {`(${a.allergy}) ${a.severity}${a.details ? ` : ${a.details}` : ''}`}
                                        </span>
                                    ))
                                ) : (
                                    <span>None on file</span>
                                )}
                            </div>
                            <div className="update-child-field">
                                <Card.Subtitle className="text-muted mb-1">Social / Emotional Needs</Card.Subtitle>
                                <span>{r.child.social_emotional_needs || 'None on file'}</span>
                            </div>
                        </Stack>
                    </Card.Body>
                </Card>
            ))}
        </Stack>
    );
};
